<div class="card mat-elevation-z0">
  <ng-content></ng-content>
</div>
